import React from 'react';

function ShineIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            fill="none"
            viewBox="0 0 17 17"
            {...props}
        >
            <path
                fill="#FDD835"
                d="M16.413 8.696l-1.951-.629c-1.249-.412-1.98-1.422-2.323-2.69l-.859-4.184c-.022-.082-.077-.193-.245-.193-.141 0-.223.11-.245.193l-.859 4.185c-.344 1.269-1.074 2.279-2.322 2.69l-1.952.63c-.275.09-.28.479-.005.572l1.965.677c1.244.413 1.97 1.422 2.314 2.685l.86 4.137c.023.083.07.231.246.231.186 0 .222-.148.245-.231l.86-4.137c.344-1.265 1.07-2.273 2.314-2.685l1.965-.677c.272-.095.268-.484-.008-.574z"
            ></path>
            <path
                fill="#FFEE58"
                d="M16.598 8.871a.295.295 0 00-.185-.175l-1.951-.629c-1.248-.412-1.98-1.422-2.323-2.69l-.859-4.184c-.012-.047-.057-.134-.109-.16l.277 4.199c.206 1.916.383 2.818 1.913 3.082l3.237.557z"
            ></path>
            <path
                fill="#F4B400"
                d="M16.602 9.09l-3.384.776c-1.192.303-1.85.993-1.85 2.8L11.038 17c.113-.011.205-.073.245-.23l.86-4.137c.345-1.265 1.07-2.274 2.314-2.686l1.965-.676a.3.3 0 00.181-.181z"
            ></path>
            <path
                fill="#FDD835"
                d="M5.237 12.335c-1.167-.385-1.273-.819-1.47-1.552L3.28 9.07c-.03-.11-.318-.11-.349 0l-.332 1.584c-.197.73-.618 1.31-1.335 1.547l-1.143.495c-.158.052-.161.277-.003.33l1.152.407c.714.237 1.132.817 1.33 1.544l.333 1.516c.03.11.318.11.347 0l.39-1.509c.197-.731.5-1.313 1.47-1.55l1.082-.408a.174.174 0 00-.003-.33l-.98-.36z"
            ></path>
            <path
                fill="#FFEE58"
                d="M3.371 10.758c.12 1.101.18 1.407 1.072 1.635l1.859.363a.162.162 0 00-.086-.06l-.98-.36c-1.024-.35-1.307-.796-1.5-1.687-.191-.89-.396-1.472-.396-1.472-.071-.192-.173-.182-.173-.182l.204 1.763z"
            ></path>
            <path
                fill="#F4B400"
                d="M3.405 14.601c0-1.038.567-1.552 1.47-1.552l1.403-.057s-.081.108-.223.141l-.916.299c-.777.312-1.132.469-1.373 1.532 0 0-.31 1.237-.37 1.367-.08.182-.177.22-.177.22l.186-1.95z"
            ></path>
            <path
                fill="#F4B400"
                stroke="#F4B400"
                strokeMiterlimit="10"
                strokeWidth="1.157"
                d="M7.749 4.117c.078-.027.075-.14-.004-.162l-1.082-.29a.668.668 0 01-.468-.463L5.77 1.444c-.02-.086-.142-.086-.163.001l-.401 1.751a.663.663 0 01-.476.472l-1.075.279c-.08.021-.085.133-.007.161l1.134.392a.67.67 0 01.421.442l.405 1.623c.021.084.141.086.162 0l.42-1.629a.669.669 0 01.425-.438l1.135-.381z"
            ></path>
        </svg>
    );
}

export default ShineIcon;
